var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocalShipping = function SvgLocalShipping(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "local_shipping_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#local_shipping_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 20a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 3 17H2a.97.97 0 0 1-.712-.288A.97.97 0 0 1 1 16V6q0-.824.587-1.412A1.93 1.93 0 0 1 3 4h12q.824 0 1.413.588Q17 5.175 17 6v2h2a1.99 1.99 0 0 1 1.6.8l2.2 2.925a.9.9 0 0 1 .15.275q.05.15.05.325V16q0 .424-.288.712A.97.97 0 0 1 22 17h-1q0 1.25-.875 2.125A2.9 2.9 0 0 1 18 20a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 15 17H9q0 1.25-.875 2.125A2.9 2.9 0 0 1 6 20m0-2q.424 0 .713-.288A.97.97 0 0 0 7 17a.97.97 0 0 0-.287-.712A.97.97 0 0 0 6 16a.97.97 0 0 0-.713.288A.97.97 0 0 0 5 17q0 .424.287.712Q5.576 18 6 18m-3-3h.8q.425-.45.975-.725A2.7 2.7 0 0 1 6 14q.675 0 1.225.275T8.2 15H15V6H3zm15 3q.424 0 .712-.288A.97.97 0 0 0 19 17a.97.97 0 0 0-.288-.712A.97.97 0 0 0 18 16a.97.97 0 0 0-.712.288A.97.97 0 0 0 17 17q0 .424.288.712.287.288.712.288m-1-5h4.25L19 10h-2z"
  }))));
};
export default SvgLocalShipping;